import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { createRouter, createWebHistory } from 'vue-router'
import Toast from 'vue-toastification'
import 'vue-toastification/dist/index.css'

import App from './App.vue'
import './style.css'

// Import views
import UploadReport from './views/UploadReport.vue'
import Results from './views/Results.vue'
import ResultsV2 from './views/ResultsV2.vue'
import Audit from './views/Audit.vue'
import Landing from './views/Landing.vue'
import Admin from './views/Admin.vue'
import Reports from './views/Reports.vue'

// Router configuration
const routes = [
  { path: '/', name: 'Landing', component: Landing },
  { path: '/upload', name: 'Upload', component: UploadReport },
  { path: '/reports', name: 'Reports', component: Reports },
  { path: '/results/:reportId', name: 'Results', component: Results },
  { path: '/results_v2/:reportId', name: 'ResultsV2', component: ResultsV2 },
  { path: '/audit/:reportId', name: 'Audit', component: Audit },
  { path: '/admin', name: 'Admin', component: Admin }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// Create app
const app = createApp(App)

// Use plugins
app.use(createPinia())
app.use(router)
app.use(Toast, {
  position: 'top-right',
  timeout: 3000,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: false,
  closeButton: 'button',
  icon: true,
  rtl: false
})

app.mount('#app')
